import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import { useHandleError } from "./useHandleError";

export function useRealAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const handleError = useHandleError();

  useEffect(() => {
    const fetchAccounts = async () => {
      setLoadingAccounts(true);
      try {
        const res = await axios.get(`${BASE_URL}/MT5M/real_accounts_number_list`, { headers: getApiHeaders() });
        if (res.data.code === 200) {
          setAccounts(res.data.data || []);
        } else {
          setAccounts([]);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoadingAccounts(false);
      }
    };
    
    fetchAccounts();
  }, [handleError]);

  return { accounts, loadingAccounts };
}
